@if (!loading){
	<div class="module-bar-fixed">
		<button mat-icon-button (mousedown)="appService.goBack()">
			<mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
		</button>
		<span class="title text-truncate">{{ 'OAT.join_tab_title' | translate }}</span>
	</div>

	<div class="module-body-fixed">
		<div class="my-panel mb-base no-shadow text-base condensed-fields">
			<div class="my-panel-body">
				<blockquote class="px-2">{{ 'OAT.join_tab_details_info' | translate }}</blockquote>
				<form #f="ngForm" [formGroup]="contactForm" class="condensed-fields">

					<mat-form-field appearance="outline">
						<mat-label>{{ 'enter_order_no' | translate }}</mat-label>
						<input #orderno name="orderNumber" matInput formControlName="orderNumber" inputmode="numeric"
							   pattern="[0-9]*" required>
					</mat-form-field>

				</form>
			</div>
		</div>
		<div class="">
			<button mat-raised-button color="accent" class="lg rounded btn-block" type="button"
					(click)="joinSharedOrder()">
				{{ 'continue' | translate }}
			</button>
		</div>
	</div>
}

